<template>
  <v-row no-gutters>
    <v-col xl="3" cols="4" class="pa-0" v-for="status in availableStatuses" :key="status.label">
      <template>
        <v-checkbox
          :label="status.label"
          :value="status.value"
          :color="status.color"
          v-model="selectedStatuses"
          dense
          hide-details
          class="checkboxOverride"
          @change="statusFilter"
        ></v-checkbox>

      </template>

    </v-col>
  </v-row>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import translate from '@/utils/genTable/multilanguageHelper.js'
import store from '@/store/store'
import EventBus from '../../../event-bus'
import mapMixin from '../mapMixin'

export default {
  name: 'RealTimeVehicleStatusFilterComponent',
  mixins: [mapMixin],
  data() {
    return {
      selectedStatuses: ['Moving', 'Stopped', 'Inactive', 'StoppedTurnedOn']
    }
  },
  mounted() {
    var that = this
    EventBus.$on('VEHICLE_STREAM_PACKET_ARRIVED', function(vehicleData) {
      that.statusFilter()
    })
  },
  computed: {
    ...mapState('map', ['vehicles', 'realTimeRoutes']),
    ...mapGetters('filters', ['getFilterFunction']),
    availableStatuses() {
      var statusesList = [
        {
          label: translate('Moving', 'mapFilters'),
          value: 'Moving',
          color: 'light-green lighten-3'
        },
        {
          label: translate('Stopped', 'mapFilters'),
          value: 'Stopped',
          color: 'cyan lighten-3'
        },
        {
          label: translate('Inactive', 'mapFilters'),
          value: 'Inactive',
          color: 'deep-orange lighten-3'
        },
      ]

      if(this.useYellowPacketColor) {
        statusesList.push({
          label: translate('Stopped (turned on)', 'mapFilters'),
          value: 'StoppedTurnedOn',
          color: 'yellow lighten-3'
        });
      }
      return statusesList
    }
  },
  methods: {
    statusFilter() {
      store.dispatch('filters/setVehicleStatus', this.selectedStatuses)
      this.getFilterFunction.forEach(fnc => {
        fnc(this.vehicles, this.realTimeRoutes)
      })
    }
  }
}
</script>

<style scoped>
.checkboxOveride {
  margin-top: 4px;
  padding-top: 0px;
}
.checkboxOveride >>> div > div > div {
  margin-right: 0px;
}
</style>
